module.exports = __webpack_public_path__ + "static/media/envelope.1882b3a8.png";